const formatTranlations = (arr) => {
  const translationsObject = arr && arr.reduce((acc, current) => {
    acc[current.key] = current.string;
    return acc;
  }, {});
  return translationsObject;
};

export default formatTranlations;
